import { Component, OnInit } from '@angular/core';
import {
  animate, state, style, transition, trigger
} from '@angular/animations';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GameService } from '../services/game.service';
import { MatDialog } from '@angular/material/dialog';
import { GameListModalComponent } from '../modals/game-list-modal/game-list-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('slide', [
      state('top', style({ transform: 'translateY(0)'})),
      state('down', style({ transform: 'translateY(100%)'})),
      transition('* => *', animate(300))
  ])]
})
export class HeaderComponent implements OnInit {
  showMenu = true;
  showGameLink = true;
  menuPosition = 'top';
  missingContact = '';
  warn2FA = false;
  ver = ""
  liveGames: GameStub[] = [];
  modalRef;

  constructor(
    private router: Router,
    private authService: AuthService,
    private gameServe: GameService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getGames();
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        if (event.url.includes('auth')) this.showMenu = false;
        else {
          this.showMenu = true;
          if (event.url.includes('/game/')) {
            this.showGameLink = false;
          }
          else {
            this.getGames();
            this.showGameLink = true;
          }
        }
      }
    });
    this.ver = localStorage.getItem("api_version")
  }

  getGames() {
    this.gameServe.getCurrentGames()
    .subscribe((res: GameStub[]) => {
      this.liveGames = res;
    })
  }

  toggleMenu(): void {
    this.menuPosition = (this.menuPosition === 'top') ? 'down' : 'top';
  }

  navigateTo(event: MouseEvent, screen: string): void {
    event.stopPropagation();

    if (screen === 'auth') {
      this.authService.setToken(null);
    }

    if (screen === 'profile') this.warn2FA = false;

    this.menuPosition = 'top';
    this.router.navigate([`/${screen}`]);
    // setTimeout(() => this.router.navigate(['/' + screen]), 300);
  }

  startGoToGame() {
    if (!this.liveGames.length) return;
    if (this.liveGames.length === 1) this.goToGame(0);
    else {
      this.modalRef = this.dialog.open(GameListModalComponent, {data: {
        modalClose: () => this.modalRef.close(),
        gameStubs: this.liveGames
      }})
    }
  }

  goToGame(index: number) {
    this.router.navigate([`/game/${this.liveGames[index].gameid}`]);
  }

  navigateToExternal(link: string) {
  	window.open(`https://${link}`, "_blank");
  }

  set2FABanner(user: User) {
  	if (!user.email) this.missingContact = 'email'
  	if (!user.phone) this.missingContact = 'phone number'
  	if (this.missingContact) {
  		this.warn2FA = sessionStorage.getItem('dismissed_2fa_warn') ? false : true;
  	}
  }

  dismiss2FA() {
  	this.warn2FA = false;
  	sessionStorage.setItem('dismissed_2fa_warn', 'yes')
  }

}
